/**
 * Textarea — DS Atom
 */

import styles from './Textarea.module.css';

interface TextareaProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  hint?: string;
  disabled?: boolean;
  rows?: number;
  id?: string;
  className?: string;
}

export function Textarea({
  label, placeholder, value, onChange, error, hint,
  disabled = false, rows = 4, id, className = '',
}: TextareaProps) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {label && <label className={styles.label} htmlFor={id}>{label}</label>}
      <textarea
        id={id}
        className={`${styles.textarea} ${error ? styles.textareaError : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange?.(e.target.value)}
        disabled={disabled}
        rows={rows}
      />
      {error && <span className={styles.error}>{error}</span>}
      {hint && !error && <span className={styles.hint}>{hint}</span>}
    </div>
  );
}
